export default "__VITE_ASSET__BOvaEsDt__"